<template>
  <div class="showmodel anim" v-if="isShow" @click="closeShow()">
    <div class="showmodel-div">
      <img src="../../../../assets/img/test/assiant_2wml.png" />
      <img src="../../../../assets/img/test/assiant_2wm111.jpg" class="two-wm" />
    </div>
  </div>
</template>

<script>
import "./anim.css";
export default {
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    letShow() {
      this.isShow = true;
    },
    closeShow() {
      this.isShow = false;
    },
  },
};
</script>

<style lang=less scoped>
.showmodel {
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.showmodel-div {
  position: relative;
  /* background: white; */
  width: 300px;
  margin: 0 90rpx;
  height: 9rem;
  border-radius: 20rpx;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  .two-wm {
    position: absolute;
    top: 84px;
    left: 49px;
    width: 70%;
    height: 70%;
  }
}
</style>